<template>
    <div class=" d-flex justify-content-start gap-2 align-items-center">
        <label for="q-weight">Add Weight Per Question</label>
        <input id="q-weight" autocomplete="off" type="number" min="0" max="999" class="weight-style"
               @input="enterNumberHandler"
               v-model="template.questions[type].weight"/>
        <span class="text-danger" v-if="template.questions[type]['errors']['weight']['isError']">{{ template.questions[type]['errors']['weight']['message']}}</span>
    </div>
</template>

<script>
    import {toRef, ref} from "vue";

    export default {
        name: 'app',
        props: {
            template: Object,
            type: String
        },
        setup(props, context) {

            const template = toRef(props, 'template');
            const type = toRef(props, 'type');

            const enterNumberHandler = (e) => {
                e.target.value = e.target.value.replace(/^-$/g, '');

                if( (+e.target.value === 0) || (+e.target.value < 0) ){
                    template.value.questions[type.value]['errors']['weight']['isError'] = true
                    template.value.questions[type.value]['errors']['weight']['message'] = '*Weight must be more than 0'
                }else if(+e.target.value > 999){
                    template.value.questions[type.value].weight = 999;
                }else{
                    template.value.questions[type.value]['errors']['weight']['isError'] = false
                }
            };

            return {
                template,
                type,
                enterNumberHandler
            }
        }
    }

</script>

<style scoped>
    .weight-style {
        background-color: transparent;
        border: 1px solid #39525C;
        border-radius: 4px;
        width: 86px;
        height: 32px;
        color: var(--main-color);
        padding: 10px;
    }
</style>